export default __webpack_public_path__ + "static/media/IS.7601b0a5.svg";